import React from 'react'
import { SearchErrorMessageProps } from './types'

function SearchErrorMessage({ errorMessage }: SearchErrorMessageProps) {
  return (
    <div className="search-screen__no-results">
      <p className="search-screen__no-results-text">{errorMessage}</p>
    </div>
  )
}

export default SearchErrorMessage
